/**
 * Constantes padronizadas para storage
 * Todas as chaves seguem o padrão: cdr:{categoria}:{nome}
 */

import { logger } from '../terminalLogger';
export const STORAGE_KEYS = {
  // Auth (já implementado no TokenService)
  ACCESS_TOKEN: 'cdr:auth:accessToken',
  REFRESH_TOKEN: 'cdr:auth:refreshToken',
  USER_DATA: 'cdr:auth:userData',
  IMPERSONATE_ROLE: 'cdr:auth:impersonateRole',
  ACTIVE_PERM_ID: 'cdr:auth:activePermId', // ✅ NOVO: Permissão ativa selecionada pelo usuário
  
  // Export & Save
  EXPORT_CONFIG: 'cdr:export:config',
  CURRENT_SAVE_DATA: 'cdr:export:currentSaveData',
  
  // UI State
  CHECKLIST_PROGRESS: 'cdr:ui:checklistProgress',
  
  // Legacy keys (para migração)
  LEGACY: {
    ACCESS_TOKEN: 'accessToken',
    USER_DATA: 'userData',
    IMPERSONATE_ROLE: 'impersonateRole',
    EXPORT_CONFIG: 'EXPORT_CONFIG',
    CURRENT_SAVE_DATA: 'currentSaveData',
    CHECKLIST_PROGRESS: 'checklistProgress'
  }
} as const;

/**
 * Migra uma chave legada para o novo padrão
 * @param legacyKey Chave legada
 * @param newKey Nova chave padronizada
 * @param storage Tipo de storage ('localStorage' | 'sessionStorage')
 */
export function migrateStorageKey(
  legacyKey: string, 
  newKey: string, 
  storage: 'localStorage' | 'sessionStorage' = 'localStorage'
): void {
  try {
    const storageObj = storage === 'localStorage' ? localStorage : sessionStorage;
    const value = storageObj.getItem(legacyKey);
    
    if (value !== null) {
      storageObj.setItem(newKey, value);
      storageObj.removeItem(legacyKey);
      logger.debug(`🔄 Migrated storage key: ${legacyKey} → ${newKey}`);
    }
  } catch (error) {
    logger.warn(`⚠️ Failed to migrate storage key ${legacyKey}:`, error);
  }
}

/**
 * Limpa todas as chaves legadas do storage
 */
export function cleanLegacyStorageKeys(): void {
  const legacyKeys = Object.values(STORAGE_KEYS.LEGACY);
  
  legacyKeys.forEach(key => {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (error) {
      logger.warn(`⚠️ Failed to clean legacy key ${key}:`, error);
    }
  });
  
  logger.debug('🧹 Legacy storage keys cleaned');
}
